<div class="identifier-first-signin registration-popup" [class.ciam-v6-shell]="ciamV6Com">
  <ng-container *ngIf="ciamV6Com && step === 'email'">
    <div class="row">
      <div class="col-lg-12 text-center ciam-v6-hero">
        <h2 class="mg-btm-12">Sign up or sign in</h2>
        <p class="ciam-v6-subcopy">We'll verify your account, or help you create one.</p>
      </div>
    </div>
    <app-alert [alertService]="alertService"></app-alert>
    <form [formGroup]="emailForm" (ngSubmit)="onEmailContinue()" novalidate>
      <div class="row mg-top-16">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div
            class="form-group ciam-v6-email-slot"
            [ngClass]="{ 'ng-invalid': emailForm.get('email')?.invalid && emailForm.get('email')?.touched }"
          >
            <label for="emailV6">Email</label>
            <input
              type="text"
              class="form-control"
              id="emailV6"
              formControlName="email"
              placeholder="Enter your email"
              autocomplete="email"
              (blur)="onIdentifierEmailBlur()"
            />
            <app-validation-message [control]="emailForm.controls.email" class="form-error ciam-v6-field-errors"></app-validation-message>
          </div>
        </div>
      </div>
      <div class="form-error valid-error" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="row mg-top-24">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
          <button type="submit" class="btn wb-btn-default ciam-v6-continue" [disabled]="loading || disableContinue" [attr.aria-busy]="loading">
            Continue
            <span *ngIf="loading" class="loading-animation"></span>
          </button>
        </div>
      </div>
    </form>
    <div class="row mg-top-24">
      <div class="col-lg-12 ciam-v6-or-wrap" aria-hidden="true">
        <span class="ciam-v6-or">or</span>
      </div>
    </div>
    <div class="row ciam-v6-socials">
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
        <button type="button" class="btn social-fb" (click)="onSocialClick('facebook')" [disabled]="loading" aria-label="Continue with Facebook"><span class="sr-only">Continue with Facebook</span></button>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
        <button type="button" class="btn social-google" (click)="onSocialClick('google')" [disabled]="loading" aria-label="Continue with Google"><span class="sr-only">Continue with Google</span></button>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
        <button type="button" class="btn social-apple" (click)="onSocialClick('apple')" [disabled]="loading" aria-label="Continue with Apple"><span class="sr-only">Continue with Apple</span></button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!ciamV6Com">
  <div class="row" *ngIf="step === 'email'">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h2 class="mg-btm-32">Sign In With:</h2>
    </div>
  </div>

  <div class="row" *ngIf="step === 'email'">
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
      <button type="button" class="btn social-fb" (click)="onSocialClick('facebook')" [disabled]="loading" aria-label="Continue with Facebook"><span class="sr-only">Continue with Facebook</span></button>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
      <button type="button" class="btn social-google" (click)="onSocialClick('google')" [disabled]="loading" aria-label="Continue with Google"><span class="sr-only">Continue with Google</span></button>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
      <button type="button" class="btn social-apple" (click)="onSocialClick('apple')" [disabled]="loading" aria-label="Continue with Apple"><span class="sr-only">Continue with Apple</span></button>
    </div>
  </div>
  </ng-container>

  <ng-container *ngIf="!ciamV6Com && step === 'email'">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="mg-btm-9 mg-top-12">or Sign In With Email</h2>
      </div>
    </div>
    <app-alert [alertService]="alertService"></app-alert>
    <form [formGroup]="emailForm" (ngSubmit)="onEmailContinue()" novalidate>
      <div class="row mg-top-32">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="form-group" [ngClass]="{ 'ng-invalid': emailForm.get('email')?.invalid && emailForm.get('email')?.touched }">
            <label for="email">Email Address*</label>
            <input type="text" class="form-control" id="email" formControlName="email" placeholder="Enter your email" autocomplete="email" />
            <app-validation-message [control]="emailForm.controls.email" class="form-error"></app-validation-message>
          </div>
        </div>
      </div>
      <div class="form-error valid-error" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="row mg-top-24">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button type="submit" class="btn wb-btn-default center-block" [disabled]="loading || disableContinue" [attr.aria-busy]="loading">
            Continue
            <span *ngIf="loading" class="loading-animation"></span>
          </button>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="step === 'password' && !ciamV6Com">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="mg-btm-9 mg-top-12">Enter your password</h2>
      </div>
    </div>
    <app-alert [alertService]="alertService"></app-alert>
    <form [formGroup]="passwordForm" (ngSubmit)="onPasswordSubmit()" novalidate>
      <div class="row mg-top-32">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="form-group">
            <label>Email</label>
            <div class="form-control-static">{{ emailValue }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="form-group" [ngClass]="{ 'ng-invalid': passwordForm.get('password')?.invalid && passwordForm.get('password')?.touched }">
            <label for="password">Password*</label>
            <input type="password" class="form-control" id="password" formControlName="password" />
            <app-validation-message [control]="passwordForm.controls.password" class="form-error"></app-validation-message>
            <span role="button" (click)="showModal('app-forgot-password')" class="forget-sign-link text-right"> Forgot Password? </span>
          </div>
        </div>
      </div>
      <div class="row mg-top-24">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button type="submit" class="btn wb-btn-default center-block" [disabled]="loading || passwordForm.invalid">
            Sign In
            <span *ngIf="loading" class="loading-animation"></span>
          </button>
        </div>
      </div>
      <div class="text-center mg-top-18">
        <span role="button" (click)="onBack()" class="forget-sign-link"> Back </span>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="step === 'otpConfirm'">
    <div *ngIf="otpRateLimitBanner" class="row">
      <div class="col-lg-12">
        <div class="alert alert-danger ciam-v6-rate-banner" role="alert">
          <span>{{ otpRateLimitBanner }}</span>
          <a *ngIf="otpShowContactUs" href="/contact-us" class="ciam-v6-inline-help">Contact us</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="mg-btm-9 mg-top-12">We'll send a code</h2>
        <span class="hint-text">We'll send a one-time code to {{ maskedIdentifier }}</span>
      </div>
    </div>
    <div class="form-error valid-error" *ngIf="errorMessage">{{ errorMessage }}</div>
    <div class="row mg-top-24">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <button type="button" class="btn wb-btn-default center-block" (click)="onOtpSendCode()" [disabled]="loading || otpContinueDisabled">
          {{ loading ? 'Sending...' : 'Send Code' }}
        </button>
      </div>
    </div>
    <div class="text-center mg-top-18">
      <span role="button" (click)="onBack()" class="forget-sign-link"> Back </span>
    </div>
  </ng-container>

  <ng-container *ngIf="ciamV6Com && step === 'facebookEmailCollection'">
    <div class="row">
      <div class="col-lg-12 text-center ciam-v6-hero">
        <h2 class="mg-btm-12">We need your email</h2>
        <p class="ciam-v6-subcopy">Facebook did not share an email. Enter one so we can verify it and finish creating your account.</p>
      </div>
    </div>
    <form [formGroup]="emailForm" (ngSubmit)="onFacebookEmailContinue()" novalidate>
      <div class="row mg-top-16">
        <div class="col-lg-12">
          <div
            class="form-group ciam-v6-email-slot"
            [ngClass]="{ 'ng-invalid': emailForm.get('email')?.invalid && emailForm.get('email')?.touched }"
          >
            <label for="facebookEmail">Email</label>
            <input
              type="text"
              class="form-control"
              id="facebookEmail"
              formControlName="email"
              placeholder="Enter your email"
              autocomplete="email"
            />
            <app-validation-message [control]="emailForm.controls.email" class="form-error ciam-v6-field-errors"></app-validation-message>
          </div>
        </div>
      </div>
      <div class="form-error valid-error" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="row mg-top-24">
        <div class="col-lg-12 text-center">
          <button type="submit" class="btn wb-btn-default ciam-v6-continue" [disabled]="loading || disableContinue" [attr.aria-busy]="loading">
            Continue
            <span *ngIf="loading" class="loading-animation"></span>
          </button>
        </div>
      </div>
      <div class="text-center mg-top-18">
        <span role="button" (click)="onBack()" class="forget-sign-link"> Back </span>
      </div>
    </form>
  </ng-container>

  <ng-template #ciamV6OtpTerms>
    <p class="hint-text text-center ciam-v6-terms">
      By continuing you agree to the
      <a href="/home/termsandconditions" target="_blank" rel="noopener noreferrer" class="ciam-v6-help-link">Terms &amp; Services</a>.
    </p>
  </ng-template>

  <ng-template #ciamV6OtpResend let-onResend="onResend">
    <div class="text-center mg-top-18">
      <span class="hint-text">Didn't get the code? </span>
      <span *ngIf="resendCooldownSeconds > 0" class="forget-sign-link disabled">Resend code in {{ resendCooldownSeconds }}s</span>
      <span
        *ngIf="resendCooldownSeconds <= 0"
        role="button"
        (click)="onResend()"
        class="forget-sign-link"
        [class.disabled]="loading || otpResendDisabled"
      >Resend code</span>
    </div>
  </ng-template>

  <ng-container *ngIf="ciamV6Com && step === 'otpVerify'">
    <div *ngIf="otpRateLimitBanner" class="row">
      <div class="col-lg-12">
        <div class="alert alert-danger ciam-v6-rate-banner" role="alert">
          <span>{{ otpRateLimitBanner }}</span>
          <a *ngIf="otpShowContactUs" href="/contact-us" class="ciam-v6-inline-help">Contact us</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 text-center ciam-v6-hero">
        <h2 class="mg-btm-12">{{ ciamOtpHeading }}</h2>
        <p class="ciam-v6-subcopy">Enter the code we sent to {{ ciamOtpDestination }}</p>
      </div>
    </div>
    <form [formGroup]="otpForm" (ngSubmit)="onOtpVerify()" novalidate>
      <div class="row mg-top-16">
        <div class="col-lg-12">
          <div
            class="form-group"
            [ngClass]="{ 'ng-invalid': (otpForm.get('otpCode')?.invalid && otpForm.get('otpCode')?.touched) || !!errorMessage }"
          >
            <label for="otpCodeV6">Code</label>
            <input
              type="text"
              class="form-control"
              id="otpCodeV6"
              formControlName="otpCode"
              autocomplete="one-time-code"
              placeholder="Enter 6-digit code"
              maxlength="6"
            />
            <app-validation-message [control]="otpForm.controls.otpCode" class="form-error"></app-validation-message>
            <div class="form-error valid-error ciam-v6-otp-error" *ngIf="errorMessage" role="alert">{{ errorMessage }}</div>
          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="ciamV6OtpTerms"></ng-container>
      <div class="row mg-top-24">
        <div class="col-lg-12 text-center">
          <button type="submit" class="btn wb-btn-default ciam-v6-continue" [disabled]="loading || otpForm.invalid || otpContinueDisabled" [attr.aria-busy]="loading">
            {{ loading ? 'Verifying...' : 'Continue' }}
          </button>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="ciamV6OtpResend; context: { onResend: ciamResendOtpVerify }"></ng-container>
    </form>
  </ng-container>

  <ng-container *ngIf="!ciamV6Com && step === 'otpVerify'">
    <div *ngIf="otpRateLimitBanner" class="row">
      <div class="col-lg-12">
        <div class="alert alert-danger ciam-v6-rate-banner" role="alert">
          <span>{{ otpRateLimitBanner }}</span>
          <a *ngIf="otpShowContactUs" href="/contact-us" class="ciam-v6-inline-help">Contact us</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="mg-btm-9 mg-top-12">Enter code</h2>
        <span class="hint-text">Enter the code we sent to {{ maskedIdentifier }}.</span>
      </div>
    </div>
    <form [formGroup]="otpForm" (ngSubmit)="onOtpVerify()" novalidate>
      <div class="row mg-top-16">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="form-group" [ngClass]="{ 'ng-invalid': otpForm.get('otpCode')?.invalid && otpForm.get('otpCode')?.touched }">
            <label for="otpCode">Code</label>
            <input type="text" class="form-control" id="otpCode" formControlName="otpCode" autocomplete="one-time-code"
              placeholder="Enter 6-digit code" maxlength="6" />
            <app-validation-message [control]="otpForm.controls.otpCode" class="form-error"></app-validation-message>
          </div>
        </div>
      </div>
      <div class="form-error valid-error" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="row mg-top-24">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button type="submit" class="btn wb-btn-default center-block" [disabled]="loading || otpForm.invalid || otpContinueDisabled">
            {{ loading ? 'Verifying...' : 'Verify' }}
          </button>
        </div>
      </div>
      <div class="text-center mg-top-18">
        <span role="button" (click)="onResendOtp()" class="forget-sign-link mg-right-8" [class.disabled]="loading || otpResendDisabled">Resend code</span>
        <span role="button" (click)="onBack()" class="forget-sign-link"> Back </span>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="ciamV6Com && step === 'signupProfile'">
    <div class="row">
      <div class="col-lg-12 text-center ciam-v6-hero">
        <h2 class="mg-btm-12">Create An Account</h2>
        <p class="ciam-v6-subcopy ciam-v6-signup-profile-lead">
          Add your name and phone number to complete account setup, start earning points, and unlock personalized offers.
        </p>
      </div>
    </div>
    <app-alert [alertService]="alertService"></app-alert>
    <div *ngIf="otpRateLimitBanner" class="row">
      <div class="col-lg-12">
        <div class="alert alert-danger ciam-v6-rate-banner" role="alert">
          <span>{{ otpRateLimitBanner }}</span>
          <a *ngIf="otpShowContactUs" href="/contact-us" class="ciam-v6-inline-help">Contact us</a>
        </div>
      </div>
    </div>
    <form [formGroup]="signupProfileForm" (ngSubmit)="onSignupProfileContinue()" novalidate class="ciam-v6-signup-profile-form">
      <div class="row mg-top-16">
        <div class="col-lg-12">
          <div class="form-group ciam-v6-email-slot" *ngIf="socialEmail">
            <label>Email</label>
            <div class="form-control-static ciam-v6-static-value">{{ socialEmail }}</div>
          </div>
          <div
            class="form-group ciam-v6-email-slot"
            [ngClass]="{ 'ng-invalid': signupProfileForm.get('firstname')?.invalid && signupProfileForm.get('firstname')?.touched }"
          >
            <label for="signupFirstName">First Name</label>
            <input
              type="text"
              class="form-control"
              id="signupFirstName"
              formControlName="firstname"
              maxlength="20"
              autocomplete="given-name"
            />
            <app-validation-message [control]="signupProfileForm.controls.firstname" class="form-error ciam-v6-field-errors"></app-validation-message>
          </div>
          <div
            class="form-group ciam-v6-email-slot"
            [ngClass]="{ 'ng-invalid': signupProfileForm.get('lastname')?.invalid && signupProfileForm.get('lastname')?.touched }"
          >
            <label for="signupLastName">Last Name</label>
            <input
              type="text"
              class="form-control"
              id="signupLastName"
              formControlName="lastname"
              maxlength="20"
              autocomplete="family-name"
            />
            <app-validation-message [control]="signupProfileForm.controls.lastname" class="form-error ciam-v6-field-errors"></app-validation-message>
          </div>
          <div
            class="form-group ciam-v6-email-slot ciam-v6-phone-field"
            [ngClass]="{ 'ng-invalid': !!signupProfilePhoneSendError }"
          >
            <label for="signupPhone">Phone Number (optional)</label>
            <input
              type="tel"
              class="form-control"
              id="signupPhone"
              formControlName="phone"
              maxlength="16"
              autocomplete="tel"
              placeholder="(555) 555-5555"
            />
            <div class="form-error valid-error ciam-v6-otp-error" *ngIf="signupProfilePhoneSendError" role="alert">
              {{ signupProfilePhoneSendError }}
            </div>
            <span class="hint-text ciam-v6-phone-disclaimer">
              We'll send a text to confirm your number. Standard message and data rates apply.
            </span>
          </div>
          <div class="form-group signup-checkbox ciam-v6-signup-email-toggle">
            <app-wb-selector
              [selectorType]="'checkbox'"
              [group]="signupProfileForm"
              [controlName]="'addToEmail'"
              [inputId]="'addToEmailIdentifierFirst'"
              [labels]="signupEmailOffersLabel"
              [value]="0"
            ></app-wb-selector>
          </div>
        </div>
      </div>
      <div class="row mg-top-24">
        <div class="col-lg-12 text-center">
          <button type="submit" class="btn wb-btn-default ciam-v6-continue" [disabled]="disableSignupProfileContinue || loading">
            Continue
          </button>
        </div>
      </div>
    </form>
    <div class="row mg-top-24 ciam-v6-signup-profile-footer">
      <div class="col-lg-12 text-center">
        <p class="ciam-v6-help mg-btm-8">
          Having trouble signing in?
          <a href="/contact-us" class="ciam-v6-help-link">Get help</a>
        </p>
        <div class="ciam-v6-or-wrap" aria-hidden="true">
          <span class="ciam-v6-or">or</span>
        </div>
        <span role="button" class="forget-sign-link" (click)="tryDifferentSignupMethod()">Try a different method</span>
      </div>
    </div>
<!--     <div class="text-center mg-top-18">
      <span role="button" (click)="onBack()" class="forget-sign-link"> Back </span>
    </div> -->
  </ng-container>

  <ng-container *ngIf="ciamV6Com && step === 'signupPhoneOtp'">
    <div *ngIf="otpRateLimitBanner" class="row">
      <div class="col-lg-12">
        <div class="alert alert-danger ciam-v6-rate-banner" role="alert">
          <span>{{ otpRateLimitBanner }}</span>
          <a *ngIf="otpShowContactUs" href="/contact-us" class="ciam-v6-inline-help">Contact us</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 text-center ciam-v6-hero">
        <h2 class="mg-btm-12">{{ ciamOtpHeading }}</h2>
        <p class="ciam-v6-subcopy">Enter the code we sent to {{ ciamOtpDestination }}</p>
      </div>
    </div>
    <app-alert [alertService]="alertService"></app-alert>
    <form [formGroup]="otpForm" (ngSubmit)="onSignupPhoneOtpVerify()" novalidate>
      <div class="row mg-top-16">
        <div class="col-lg-12">
          <div
            class="form-group"
            [ngClass]="{ 'ng-invalid': (otpForm.get('otpCode')?.invalid && otpForm.get('otpCode')?.touched) || !!errorMessage }"
          >
            <label for="signupPhoneOtpCode">Code</label>
            <input
              type="text"
              class="form-control"
              id="signupPhoneOtpCode"
              formControlName="otpCode"
              autocomplete="one-time-code"
              placeholder="Enter 6-digit code"
              maxlength="6"
            />
            <app-validation-message [control]="otpForm.controls.otpCode" class="form-error"></app-validation-message>
            <div class="form-error valid-error ciam-v6-otp-error" *ngIf="errorMessage" role="alert">{{ errorMessage }}</div>
          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="ciamV6OtpTerms"></ng-container>
      <div class="row mg-top-24">
        <div class="col-lg-12 text-center">
          <button type="submit" class="btn wb-btn-default ciam-v6-continue" [disabled]="loading || otpForm.invalid || otpContinueDisabled" [attr.aria-busy]="loading">
            {{ loading ? 'Verifying...' : 'Continue' }}
          </button>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="ciamV6OtpResend; context: { onResend: ciamResendSignupPhoneOtp }"></ng-container>
    </form>
  </ng-container>

  <ng-container *ngIf="step === 'social'">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
        <h2 class="mg-btm-9 mg-top-12">Continue with your account</h2>
        <span class="hint-text">You previously signed in with </span>
        <span class="hint-text" *ngFor="let p of socialProviders; let i = index">{{ i > 0 ? ', ' : '' }}{{ getProviderLabel(p) }}</span>
        <span class="hint-text">. Click to continue.</span>
      </div>
    </div>
    <div class="row mg-top-24">
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center" *ngIf="hasProvider('google')">
        <button role="button" class="btn social-google" (click)="onSocialClick('google')" [disabled]="loading"></button>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center" *ngIf="hasProvider('facebook')">
        <button role="button" class="btn social-fb" (click)="onSocialClick('facebook')" [disabled]="loading"></button>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center" *ngIf="hasProvider('apple')">
        <button role="button" class="btn social-apple" (click)="onSocialClick('apple')" [disabled]="loading"></button>
      </div>
    </div>
    <div class="text-center mg-top-18">
      <span role="button" (click)="onBack()" class="forget-sign-link"> Back </span>
    </div>
  </ng-container>

  <div class="row" *ngIf="!ciamV6Com && step === 'email'">
    <div class="col-md-12 text-center mg-top-18">
      <span (click)="showSignupModal()" role="button" class="forget-sign-link already-link"> Need an account? Join Now</span>
    </div>
  </div>

  <ng-container *ngIf="ciamV6Com && step === 'socialChallenge'">
    <div *ngIf="otpRateLimitBanner" class="row">
      <div class="col-lg-12">
        <div class="alert alert-danger ciam-v6-rate-banner" role="alert">
          <span>{{ otpRateLimitBanner }}</span>
          <a *ngIf="otpShowContactUs" href="/contact-us" class="ciam-v6-inline-help">Contact us</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 text-center ciam-v6-hero">
        <h2 class="mg-btm-12">{{ ciamOtpHeading }}</h2>
        <p class="ciam-v6-subcopy">Enter the code we sent to {{ ciamOtpDestination }}</p>
      </div>
    </div>
    <form [formGroup]="otpForm" (ngSubmit)="onSocialChallengeVerify()" novalidate>
      <div class="row mg-top-16">
        <div class="col-lg-12">
          <div
            class="form-group"
            [ngClass]="{ 'ng-invalid': (otpForm.get('otpCode')?.invalid && otpForm.get('otpCode')?.touched) || !!errorMessage }"
          >
            <label for="socialChallengeOtpCode">Code</label>
            <input
              type="text"
              class="form-control"
              id="socialChallengeOtpCode"
              formControlName="otpCode"
              autocomplete="one-time-code"
              placeholder="Enter 6-digit code"
              maxlength="6"
            />
            <app-validation-message [control]="otpForm.controls.otpCode" class="form-error"></app-validation-message>
            <div class="form-error valid-error ciam-v6-otp-error" *ngIf="errorMessage" role="alert">{{ errorMessage }}</div>
          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="ciamV6OtpTerms"></ng-container>
      <div class="row mg-top-24">
        <div class="col-lg-12 text-center">
          <button type="submit" class="btn wb-btn-default ciam-v6-continue" [disabled]="loading || otpForm.invalid || otpContinueDisabled" [attr.aria-busy]="loading">
            {{ loading ? 'Verifying...' : 'Continue' }}
          </button>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="ciamV6OtpResend; context: { onResend: ciamResendSocialChallengeOtp }"></ng-container>
    </form>
  </ng-container>
</div>
